export default {"src":"/_next/static/media/after-ht.13d3986c.svg","height":417,"width":516,"blurWidth":0,"blurHeight":0};